import React, { useState } from "react";
import { crown } from "../../images";
import UpgradePremiumModal from "../pages/Layout/DashboardLayout/BillingDashboard/modals/UpgradePremiumModal";
const AllowedCard = () => {
    const [activeModal, setActiveModal] = useState(null)
    const openModal = ()=>{
     setActiveModal(true);
    }
    const closeModal = ()=>{
     setActiveModal(false);
    }
  return (
    <>
    {activeModal && (<UpgradePremiumModal show={activeModal} openModal={openModal} onClose={closeModal}/>)}
      <div className="card allowed-card">
        <div className="allowed-card-content">
          <div className="allowed-card-image">
            <div className="glow"></div>
            <img src={crown} alt="crown" className="img-fluid" width={50} height={50}></img>
          </div>
          <h2>
            <i className="bi bi-star-fill"></i> Premium Card
          </h2>
          <p>
            Experience the next level of premium features with our advanced
            hover animations and modern design.
          </p>
          <div className="d-flex justify-content-center">
          <button onClick={() => openModal("upgrade")}>
            <i className="bi bi-arrow-right"></i> Upgrad
          </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default AllowedCard;
